import React, { Component } from "react";
import firebase from "../Firebase";
import { Link } from "react-router-dom";
import home from "../assets/home.png";

class Show extends Component {
  constructor(props) {
    super(props);
    this.state = {
      app: {},
      key: "",
    };
  }

  componentDidMount() {
    const ref = firebase
      .firestore()
      .collection("tracker")
      .doc(this.props.match.params.id);

    ref.get().then((doc) => {
      if (doc.exists) {
        this.setState({
          app: doc.data(),
          key: doc.id,
          isLoading: false,
        });
      } else {
        console.log("No such document!");
      }
    });
  }

  render() {
    const { projname, description, status, deployment } = this.state.app;
    return (
      <div className="container">
        <div class="card mt-5">
          <div class="card-header">
            <h3 class="card-title text-primary mt-0">
              <Link to="/">
                <img src={home} alt="home icon" style={{ width: "50px" }} />
              </Link>{" "}
              {projname}
            </h3>
          </div>
          <div class="card-body">
            <p class="card-text">
              <b>Description:</b> {description}
            </p>
            <p class="card-text">
              <b>Dev. Status:</b> {status}
            </p>
            <p class="card-text">
              <b>Deployed:</b> {deployment}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Show;

/*
      <div className="container">
        <div className="panel panel-default">
          <div className="panel-heading">
            <h4
              style={{
                marginBottom: "1em",
                marginTop: "1em",
              }}
            >
              <Link to="/">
                <img src={home} alt="home icon" style={{ width: "40px" }} />{" "}
                Apps List
              </Link>
            </h4>
            <h3 className="panel-title">{this.state.app.title}</h3>
          </div>
          <div className="panel-body">
            <dl>
              <dt>Project Name:</dt>
              <dd>{projname}</dd>
              <dt>Description:</dt>
              <dd>{description}</dd>
              <dt>Status:</dt>
              <dd>{status}</dd>
              <dt>Deployment status:</dt>
              <dd>{deployment}</dd>
            </dl>
          </div>
        </div>
      </div>
*/
